export const REFERRAL_PROGRAMS_LIST = "REFERRAL_PROGRAMS_LIST";
export const REFERRAL_PROGRAMS_CREATE = "REFERRAL_PROGRAMS_CREATE";
export const REFERRAL_PROGRAMS_UPDATE = "REFERRAL_PROGRAMS_UPDATE";
export const REFERRAL_PROGRAMS_DELETE = "REFERRAL_PROGRAMS_DELETE";
export const REFERRAL_PROGRAMS_SHOW = "REFERRAL_PROGRAMS_SHOW";
export const REFERRAL_PROGRAMS_UPDATE_STATUS = "REFERRAL_PROGRAMS_UPDATE_STATUS";
export const REFERRAL_PROGRAMS_LOGS_LIST = "REFERRAL_PROGRAMS_LOGS_LIST";
export const REFERRAL_PROGRAMS_TYPE_LIST = "REFERRAL_PROGRAMS_TYPE_LIST";

